import React, { useState } from "react";
import { LogOut, Inbox, FileText, ExternalLink } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { company } from "../mock";
import SubmissionsPanel from "../components/admin/SubmissionsPanel";
import BlogPanel from "../components/admin/BlogPanel";

export default function Admin() {
  const { user, logout } = useAuth();
  const [tab, setTab] = useState("submissions");

  const tabs = [
    { id: "submissions", label: "Submissions", icon: Inbox },
    { id: "blog", label: "Blog", icon: FileText },
  ];

  return (
    <div className="min-h-screen bg-gold-soft/30">
      {/* Top bar */}
      <header className="bg-ink sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src={company.logo} alt={company.name} className="h-10 w-auto object-contain bg-white rounded-lg p-1" />
            <span className="font-display text-white text-lg hidden sm:block">Admin Console</span>
          </div>
          <div className="flex items-center gap-4">
            <a href="/" target="_blank" rel="noreferrer" className="hidden sm:flex items-center gap-1.5 text-sm text-white/60 hover:text-gold">
              View site <ExternalLink size={14} />
            </a>
            <div className="flex items-center gap-2">
              {user?.picture ? (
                <img src={user.picture} alt="" className="h-8 w-8 rounded-full ring-2 ring-gold" />
              ) : (
                <span className="h-8 w-8 rounded-full bg-gold grid place-items-center text-ink font-semibold">
                  {(user?.name || user?.email || "A").charAt(0).toUpperCase()}
                </span>
              )}
              <span className="hidden md:block text-sm text-white/80 max-w-[160px] truncate">{user?.email}</span>
            </div>
            <button onClick={logout} className="flex items-center gap-1.5 rounded-full bg-white/10 hover:bg-gold hover:text-ink text-white px-4 h-9 text-sm font-semibold transition-colors">
              <LogOut size={15} /> Logout
            </button>
          </div>
        </div>
      </header>

      {/* Tabs */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6">
        <div className="flex gap-2">
          {tabs.map((t) => {
            const active = tab === t.id;
            return (
              <button
                key={t.id}
                onClick={() => setTab(t.id)}
                className={`flex items-center gap-2 rounded-t-xl px-5 py-3 text-sm font-semibold transition-colors ${
                  active ? "bg-white text-ink shadow-sm" : "bg-transparent text-ink/50 hover:text-ink"
                }`}
              >
                <t.icon size={16} className={active ? "text-gold-dark" : ""} /> {t.label}
              </button>
            );
          })}
        </div>

        <div className="bg-white rounded-b-2xl rounded-tr-2xl shadow-sm p-4 sm:p-6 mb-10">
          {tab === "submissions" ? <SubmissionsPanel /> : <BlogPanel />}
        </div>
      </div>
    </div>
  );
}
